import { render, staticRenderFns } from "./ks_table.vue?vue&type=template&id=2f0164b8"
import script from "./ks_table.vue?vue&type=script&lang=js"
export * from "./ks_table.vue?vue&type=script&lang=js"
import style0 from "./ks_table.vue?vue&type=style&index=0&id=2f0164b8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports